import { render, staticRenderFns } from "./StorageSpaceMediaTable.vue?vue&type=template&id=06e3330c&"
import script from "./StorageSpaceMediaTable.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceMediaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports